'use client';

import { forwardRef, useContext } from 'react';

import { Label } from '../label';
import { DateTimeBlockRootContext } from './context/date-time-block-root.context';
import type { DateTimeBlockLabelPropsInterface } from './types/date-time-block-label.types';

/**
 * `DateTimeBlock.Label` is a label adjacent to the date/time selection
 *
 * @since 10.2.0
 */
export const DateTimeBlockLabel = forwardRef<HTMLLabelElement, DateTimeBlockLabelPropsInterface>(
  (props: DateTimeBlockLabelPropsInterface, forwardedRef) => {
    const { children, ...rest } = props;
    const { label } = useContext(DateTimeBlockRootContext);

    return (
      <Label
        ref={forwardedRef}
        data-c11n-component="DateTimeBlock.Label"
        data-c11n-version={__C11N_VERSION__}
        {...rest}
      >
        {label}
        {children}
      </Label>
    );
  },
);

DateTimeBlockLabel.displayName = 'DateTimeBlock.Label';
